import ResultPage from '@/components/Result/index'

const ShareDataSuccessPage = () => {
	const breadcrumbItem = [
		{
			label: '',
			link: `/`,
		},
		{
			label: 'Received Data',
			link: `/received-data`
		},
		{
			label: 'Success',
			link: `/forward/success`
		}
	]// TO CHECK

	return ResultPage({
		defaultTitle: "forwardData",
		nextLocation: '/shared-data',
		breadcrumbs: breadcrumbItem,
		layoutHeaderTxt: "dataForwardShared",
		layoutSubHeaderTxt: "dataForwardSharedMessage",
		layoutContentImgPath: "/img/success.png",
		backBtnTxt: "backToSharedData",
	});
}
export default ShareDataSuccessPage
